import { useState } from 'react'
import { Modal } from 'react-daisyui'
import { IconArrowsMove } from '@tabler/icons-react'
import { Button } from '@/components/Button.tsx'
import AlbumSelection from '@/components/AlbumSelection.tsx'
import { Album } from '@/models/album.ts'

/**
 * Reusable modal for selecting a target album to move files into.
 * Used by FileSelection (B2C) and AlbumCard (portal).
 */
export default function BulkMoveModal({ modalRef, availableAlbums, onConfirm, isLoading }: {
  modalRef: React.RefObject<HTMLDialogElement>
  availableAlbums: Album[]
  onConfirm: (targetAlbum: Album) => void
  isLoading: boolean
}) {
  const [targetAlbum, setTargetAlbum] = useState<Album | null>(null)

  return (
    <Modal ref={modalRef} className="bg-neutral">
      <Modal.Header>
        <div className="flex flex-row gap-2 justify-center">
          <div className="bg-primary text-neutral rounded-full p-1">
            <IconArrowsMove size={20} />
          </div>
          Dateien verschieben
        </div>
        <form method="dialog">
          <p className="mt-3 text-center">In welches Album verschieben?</p>
          <button disabled={isLoading} className="btn btn-sm btn-circle btn-ghost absolute right-5 top-5">✕</button>
        </form>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-2 items-center">
          <AlbumSelection
            externalAlbums={availableAlbums}
            drive={null}
            selectedAlbum={targetAlbum}
            setSelectedAlbum={setTargetAlbum}
          />
          <Button
            disabled={!targetAlbum || isLoading}
            loading={isLoading}
            className="px-5 mt-5"
            color="primary"
            onClick={() => targetAlbum && onConfirm(targetAlbum)}
          >
            Verschieben
          </Button>
          <form method="dialog">
            <Button disabled={isLoading} color="ghost">Abbrechen</Button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  )
}
